/* Native scrolling works without JS. Enhancement owns only this gallery, not variants/cart. */
(() => {
  'use strict';
  if (window.__gzPdpMediaInitialized) return;
  window.__gzPdpMediaInitialized = true;
  const init = (scope = document) => scope.querySelectorAll('[data-gz-media]:not([data-enhanced])').forEach(root => {
    const viewport = root.querySelector('[data-gz-media-viewport]');
    const slides = Array.from(root.querySelectorAll('[data-gz-media-slide]'));
    if (!viewport || !slides.length) return;
    const thumbs = Array.from(root.querySelectorAll('[data-gz-media-thumb]'));
    const prev = root.querySelector('[data-gz-media-prev]');
    const next = root.querySelector('[data-gz-media-next]');
    const count = root.querySelector('[data-gz-media-count]');
    const section = root.closest('.shopify-section') || root.parentElement;
    let selected = 0, frame = 0, suppressClick = false, touch = null, resizing = false;
    let variantMap = {};
    try { variantMap = JSON.parse(root.querySelector('[data-gz-media-variants]').textContent); } catch (_) {}
    const offset = i => slides[i].getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft - viewport.clientLeft;
    const update = (i, revealThumb = true) => {
      const old = selected;
      selected = Math.max(0, Math.min(slides.length - 1, i));
      thumbs.forEach((t, n) => { if (n === selected) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      count.textContent = `${selected + 1} / ${slides.length}`;
      if (prev) prev.disabled = selected === 0;
      if (next) next.disabled = selected === slides.length - 1;
      // Only the selected slide is keyboard-operable after enhancement.
      slides.forEach((s,n) => {
        s.inert = n !== selected;
        s.setAttribute('aria-hidden', String(n !== selected));
        if (n !== selected) {
          s.querySelectorAll('video').forEach(v => v.pause());
          if (n === old) s.querySelectorAll('iframe').forEach(f => {
            // Reset only a previously viewed external player, never autoplay it.
            const src = f.getAttribute('src'); if (src) f.setAttribute('src', src);
          });
        }
      });
      if (revealThumb && thumbs[selected]) {
        const rail = thumbs[selected].parentElement, t = thumbs[selected];
        const delta = t.getBoundingClientRect().left - rail.getBoundingClientRect().left;
        if (delta < 0) rail.scrollLeft += delta - 3;
        else if (delta + t.offsetWidth > rail.clientWidth) rail.scrollLeft += delta + t.offsetWidth - rail.clientWidth + 3;
      }
    };
    const select = i => { i = Math.max(0, Math.min(slides.length - 1, i)); update(i); viewport.scrollTo({left:offset(i), behavior:'instant'}); };
    thumbs.forEach((t,i) => t.addEventListener('click', e => { e.preventDefault(); select(i); }));
    if (prev) { prev.hidden = false; prev.addEventListener('click', () => select(selected - 1)); }
    if (next) { next.hidden = false; next.addEventListener('click', () => select(selected + 1)); }
    viewport.addEventListener('scroll', () => {
      if (resizing || frame) return;
      frame = requestAnimationFrame(() => { frame = 0; if (!resizing) update(Math.round(viewport.scrollLeft / viewport.clientWidth)); });
    }, {passive:true});
    viewport.addEventListener('keydown', e => {
      if (!e.target.closest('.gz-pdp-media__zoom')) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault(); select(selected + (e.key === 'ArrowRight' ? 1 : -1));
        slides[selected].querySelector('a')?.focus({preventScroll:true});
      }
    });
    // A swipe must not also open the lightbox on touch browsers.
    viewport.addEventListener('touchstart', e => { touch = {x:e.touches[0].clientX,y:e.touches[0].clientY}; suppressClick = false; }, {passive:true});
    viewport.addEventListener('touchmove', e => { if (touch && (Math.abs(e.touches[0].clientX-touch.x)>8 || Math.abs(e.touches[0].clientY-touch.y)>8)) suppressClick = true; }, {passive:true});
    viewport.addEventListener('click', e => { if (suppressClick) { e.preventDefault(); e.stopImmediatePropagation(); suppressClick = false; } }, true);
    const resize = new ResizeObserver(() => {
      resizing = true;
      viewport.scrollTo({left:offset(selected),behavior:'instant'});
      requestAnimationFrame(() => { resizing = false; });
    });
    resize.observe(viewport);
    const form = section.querySelector('[data-section-product-main] form[action*="/cart/add"]');
    let lastVariant = '';
    const syncVariant = () => {
      const id = form?.querySelector('[name="id"]')?.value;
      if (!id || id === lastVariant) return;
      lastVariant = id;
      const index = slides.findIndex(s => s.dataset.gzMediaSlide === variantMap[id]);
      if (index >= 0) select(index); // Never guess a color/media association.
    };
    form?.addEventListener('change', () => setTimeout(syncVariant, 0));
    root.dataset.enhanced = 'true';
    const initial = slides.findIndex(s => s.dataset.gzMediaSlide === root.dataset.initialMedia);
    select(initial >= 0 ? initial : 0);
    lastVariant = form?.querySelector('[name="id"]')?.value || '';
    // Preserve the legacy fifth sizing link without the global old accordion handler.
    section.querySelectorAll('[data-gz-gallery-guide]').forEach(link => link.addEventListener('click', e => {
      const imageIndex = slides.map(s => s.dataset.mediaKind).lastIndexOf('image');
      if (imageIndex < 0) return;
      e.preventDefault(); select(imageIndex); slides[imageIndex].querySelector('.gz-pdp-media__zoom')?.click();
    }));
    root.addEventListener('gz:media:dispose', () => resize.disconnect(), {once:true});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-gz-media]').forEach(r => r.dispatchEvent(new Event('gz:media:dispose'))));
})();

/* 2026-09-27 (owner-approved): on phones the chat bubble sat on the new thumbnail row. Keep it off the photos until the
   shopper scrolls past the gallery, then show it for the rest of the visit. Fails open: no gallery, no phone width,
   an already-open chat, or any error leaves the chat exactly as before. */
(() => {
  'use strict';
  try {
    const gallery = document.querySelector('[data-gz-media]');
    if (!gallery || !window.matchMedia('(max-width: 720px)').matches) return;
    try { if (window.$crisp && window.$crisp.is && window.$crisp.is('chat:opened')) return; } catch (_) {}
    const html = document.documentElement;
    const past = () => gallery.getBoundingClientRect().bottom < window.innerHeight * 0.5;
    if (past()) return;
    html.classList.add('gz-chat-wait');
    const release = () => { if (!past()) return; html.classList.remove('gz-chat-wait'); window.removeEventListener('scroll', release); };
    window.addEventListener('scroll', release, {passive: true});
  } catch (_) { document.documentElement.classList.remove('gz-chat-wait'); }
})();
